import { useEffect, useState } from "react"
import { useDebounceValue } from "usehooks-ts"

export default function InfiniteScroll({
  children,
  onNextPage,
  hasMorePages,
  scrollTargetId,
}) {
  const [scrollPercentage, setScrollPercentage] = useState(0)
  const debouncedScrollPercentage = useDebounceValue(scrollPercentage)[0]

  useEffect(() => {
    const scroller = document.getElementById(scrollTargetId)
    scroller.addEventListener("scroll", () => {
      setScrollPercentage(
        scroller.scrollTop / (scroller.scrollHeight - scroller.clientHeight)
      )
    })
  }, [scrollTargetId])

  useEffect(
    () => {
      if (hasMorePages && debouncedScrollPercentage > 0.9) {
        onNextPage()
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [hasMorePages, debouncedScrollPercentage]
  )
  return <>{children}</>
}
